import { motion } from "framer-motion";

const HeroSection = () => {
    return (
        <section className="w-full">
           

            <div className="w-full">
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                    viewport={{ once: true }}
                    className="relative  shadow-2xl"
                >
                    <img
                        src="/assets/mechanical/hero.jpg"
                        alt="Luxury Car"
                        className="w-full h-[220px] md:h-[450px] lg:h-[560px] object-cover object-center"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                </motion.div>
            </div>
        </section>
    );
};

export default HeroSection;